import { _, debound, type App, type PageContext } from '@zto/zpage'

import {
  CouponBusinessScene,
  CouponCDKeyGenerateMethod,
  CouponFreeChargeType,
  CouponGrantType,
  CouponIssueLimitType,
  CouponType,
  DialogType,
  GoodsCatIds,
  YesNo,
  commonOptions, GoodsType, ZdsActivityType, DayCouponIssueLimitType, DiscountMethodType
} from '@/config'
import { extractPayloadJsonData, getCommonOptionItem, parsePayloadJsonData } from '@/utils'
import { numberCompareValidator } from '@/utils/validator'

/**
 * 新增编辑对话框
 * @returns
 */
export function addEditDialog(dialogType: DialogType = DialogType.ADD) {
  const isView = dialogType === DialogType.VIEW
  const isAdd = dialogType === DialogType.ADD


  return ({ app }: PageContext) => {


    return {
      width: 750,
      labelWidth: 110,
      itemSpan: 24,

      formAttrs: {
        disabled: isView
      },

      formItemsAttrs: {
        itemWidth: '300px'
      },

      onShow: async ({ data }: PageContext) => {
        let payload = { ...data }
        if (isView) {
          const res = await app.request({
            api: 'api/pc/coupon/queryCouponInfo',
            params: { couponCode: data.couponCode }
          })

          console.log("=================",JSON.stringify(res))

          payload = { ...payload,
            specifiedCodeList:res.specifiedGoodsList
          }
        }
        await loadBusinessCategoryData(app,payload)

        // 保险特殊处理，将三级类目赋予catId
        if (payload.businessScene === CouponBusinessScene.INSURANCE) {
          payload._catId = payload.threeLevelCatId
        } else {
          payload._catId = payload.firstLevelCatId
        }
        parsePayloadJsonData(payload)

        payload._oldData = _.deepClone(payload)

        return { payload }
      },

      formItems: [

        { label: '券名称', type: 'input', prop: 'couponName', maxlength: 14, required: true },
        {
          label: '优惠方式',
          type: 'checkbox',
          checkType: 'radio',
          prop: 'couponType',
          options: [
            { label: '直减', value: DiscountMethodType.ZHIJIAN},
            { label: '统一折扣', value: DiscountMethodType.DISCOUNT}
          ],
          dynamicAttrs: ({ data }: PageContext) => {
            const isVisible = true

            // if (!isVisible) data.appointType = YesNo.NO
            return { hidden: !isVisible, required: isVisible }
          }
        },
        { label: '折扣', type: 'input',placeholder:'请输入折扣', prop: 'jsonData_discount', maxlength: 14,
          dynamicAttrs: ({ data }: PageContext) => {

            let isVisible = true
            if (data.couponType === DiscountMethodType.DISCOUNT){
              isVisible = false
            }

            return { hidden:isVisible}
          }
        },
        { label: '直减', type: 'input',placeholder:'请输入金额', prop: 'couponPrice', maxlength: 14,
          dynamicAttrs: ({ data }: PageContext) => {

            let isVisible = true
            if (data.couponType === DiscountMethodType.ZHIJIAN){
              isVisible = false
            }

            return { hidden:isVisible}
          }
          },
        {
          label: '每日可用张数',
          type: 'input-number',
          prop: 'availableNum',
          precision: 2,
          onChange: async (model: any) => {
            reloadWriteOffRule(app, model)
          },
          dynamicAttrs: ({ data }: PageContext) => {
            let min = 0.01
            let max: number | null = 200
            const hidden = data.couponType === CouponType.FREE_CHARGE

            if (hidden) {
              min = 0
              data.couponPrice = 0
            }

            if (data.couponType === CouponType.VERTICAL_REDUCTION) {
              max = null
            }

            // 如果值大于最大值，则调整为最大值
            if (max && data.couponPrice > max) {
              data.couponPrice = max
            }

            return { hidden, required: !hidden, min, max }
          }
        },
        {
          label: '每人限领方式',
          type: 'checkbox',
          checkType: 'radio',
          prop: 'limitType',
          options: [
            { label: '每人累计限领', value: DayCouponIssueLimitType.TOTAL},
            { label: '每人每日限额', value: DayCouponIssueLimitType.DAILY }
          ],
          required: true,
          dynamicAttrs: ({ data }: PageContext) => {
            const isVisible = true

            // if (!isVisible) data.appointType = YesNo.NO
            return { hidden: !isVisible, required: isVisible }
          }
        },
        {
          label: '每人限领数量',
          type: 'input-number',
          prop: 'dayLimitNum',
          precision: 2,
          onChange: async (model: any) => {
            reloadWriteOffRule(app, model)
          },
          dynamicAttrs: ({ data }: PageContext) => {
            let min = 0.01
            let max: number | null = 200
            const hidden = data.couponType === CouponType.FREE_CHARGE

            if (hidden) {
              min = 0
              data.couponPrice = 0
            }

            if (data.couponType === CouponType.VERTICAL_REDUCTION) {
              max = null
            }

            // 如果值大于最大值，则调整为最大值
            if (max && data.couponPrice > max) {
              data.couponPrice = max
            }

            return { hidden, required: !hidden, min, max }
          }
        },
        {
          label: '累计限领数量',
          type: 'input-number',
          prop: 'cumulativeLimitNum',
          precision: 2,
          onChange: async (model: any) => {
            reloadWriteOffRule(app, model)
          },
          dynamicAttrs: ({ data }: PageContext) => {
            let min = 0.01
            let max: number | null = 200
            const hidden = data.couponType === CouponType.FREE_CHARGE

            if (hidden) {
              min = 0
              data.couponPrice = 0
            }

            if (data.couponType === CouponType.VERTICAL_REDUCTION) {
              max = null
            }

            // 如果值大于最大值，则调整为最大值
            if (max && data.couponPrice > max) {
              data.couponPrice = max
            }

            return { hidden, required: !hidden, min, max }
          }
        },
        {
          label: '券有效期(天)',
          type: 'input-number',
          prop: 'validityDay',
          min: 1,
          max: 365,
          precision: 0,
          required: true,
          default: 7
        },
        {
          label: '发放特定用户',
          type: 'checkbox',
          checkType: 'radio',
          prop: 'appointType',
          options: [
            { label: '否', value: YesNo.NO },
            { label: '是', value: YesNo.YES }
          ],
          required: true,
          default: YesNo.NO,
          dynamicAttrs: ({ data }: PageContext) => {
            const isVisible = true

            // if (!isVisible) data.appointType = YesNo.NO
            return { hidden: !isVisible, required: isVisible }
          }
        },
        {
          label: '发放类型',
          type: 'select',
          prop: 'grantType',
          options: 'CouponAppointType',
          dynamicAttrs: ({ data }: PageContext) => {
            let isVisible = true
            if (data.appointType === YesNo.NO) {
              isVisible = false
            }
            return { hidden: !isVisible, required: isVisible }
          }
        },
        {
          label: '',
          type: 'multi-input-ex',
          inputType: 'textarea',
          prop: 'appointUserList',
          rows: 3,
          maxLines: 10000,
          noHeader: true,
          resize: true,
          autoHeight: true,
          itemAttrs: { style: { width: '360px' } },
          dynamicAttrs: ({ data }: PageContext) => {
            let isVisible = true
            if (!isVisible) {
              data.appointUserList = []
            }
            if (data.appointType === YesNo.NO){
              isVisible = false
            }
            const userTip = data.grantType === CouponGrantType.DEPOT_ID ? '门店id' : '用户编码或者手机号'
            return {
              hidden: !isVisible,
              required: isVisible,
              placeholder: `最多支持10000个${userTip}，回车隔开`
            }
          }
        },
        {
          label: '活动商品',
          type: 'checkbox',
          prop: 'applicableProductType',
          checkType: 'radio',
          options: 'activityZdsType',
          default: ZdsActivityType.GOODS,
          dynamicAttrs: ({ data }: PageContext) => {
            const hidden = false
            return { hidden, required: !hidden }
          }
        },
        {
          label: '商品候选',
          type: 'multi-product-selector',
          autoHeight: true,
          prop: 'specifiedCodeList',
          labelProp: 'specifiedCodeList',
          dynamicAttrs: ({ data }: PageContext) => {
            const hidden = data.applicableProductType ===  ZdsActivityType.All
            return { hidden, required: !hidden }
          }
        },
        {
          label: '与营销活动叠加使用',
          type: 'checkbox',
          checkType: 'radio',
          prop: 'overlapWithActivity',
          options: [
            { label: '否', value: YesNo.NO },
            { label: '是', value: YesNo.YES }
          ],
          required: true,
          default: YesNo.NO,
          dynamicAttrs: ({ data }: PageContext) => {
            const isVisible = true

            // if (!isVisible) data.appointType = YesNo.NO
            return { hidden: !isVisible, required: isVisible }
          }
        }
      ],

      actions: [
        ...(isView
          ? []
          : [
              {
                name: 'submit',
                onSubmit: async (payload: any, options: any, model: any, dialogExposed: any) => {
                  const { businessScene, grantType } = payload
                  if (businessScene === CouponBusinessScene.INSURANCE && grantType === CouponGrantType.DEPOT_ID) {
                    const { showInnerDialog } = dialogExposed
                    showInnerDialog('depotIdsConfirm', payload)
                    return false
                  }

                  const ctx = app.useContext(payload)

                  const flag = await _submitCouponDialog(ctx)

                  return flag
                }
              }
            ]),
        { name: 'close' }
      ],

      innerDialogs: {
        /// 门店
        depotIdsConfirm: ({ data: outerData }: PageContext) => {
          return {
            title: '验证门店id',
            labelWidth: 100,
            itemSpan: 24,

            onShow: async () => {
              let payload = _.deepClone(outerData)

              payload._validateEnd = false

              return { payload }
            },

            onSubmit: async (payload: any, actionCfg: any, model: any, dialogExposed: any) => {
              const ctx = app.useContext(payload)

              const flag = await _submitCouponDialog(ctx)

              if (flag === false) return false

              app.triggerPageSearch()

              dialogExposed.top?.close()
            },

            cmpt: ({ data }: PageContext) => {
              return {
                type: 'CCouponDepotIdsValidator',
                depotIds: data.appointUserList,
                onValidated: (result: any) => {
                  if (!result) return

                  data._validateSuccess = result.success
                  data._validDepotIds = result.validIds
                  data._validateEnd = true
                }
              }
            },

            actions: ({ data }: PageContext) => {
              let submitLabel = data._validateSuccess ? '发放' : '跳过并发放'
              let submitDisabled = !data._validateEnd

              return [
                { name: 'close', label: '取消发放' },
                { name: 'submit', label: submitLabel, disabled: submitDisabled }
              ]
            }
          }
        }
      }
    }
  }
}

async function _submitCouponDialog({ app, data }: PageContext) {
  let payload = { ...data }

  if (data.grantType === CouponGrantType.COUPON_BAG) {
    payload.issuedNum = 0
  } else if (
    data.appointType === YesNo.YES &&
    [CouponGrantType.PHONE_NUMBER, CouponGrantType.USER_ID].includes(data.grantType) &&
    data.appointUserList?.length
  ) {
    payload.issuedNum = data.appointUserList.length
  }

  if (payload.applicableProductType === ZdsActivityType.GOODS) {
    const spuCodeList = payload.specifiedCodeList.map((el: { spuCode: any }) => el.spuCode)
    payload.specifiedCodeList = spuCodeList
  }


  if (payload.appointType === 0) {
    payload.grantType = 1
  }


  payload.secondaryCatName = getCommonOptionItem('goodsCat', payload.secondaryLevelCatId, 'label')
  payload.threeLevelCatName = getCommonOptionItem('goodsCat', payload.threeLevelCatId, 'label')

  delete payload.jsonData_llCat
  payload = extractPayloadJsonData(payload)

  delete payload._catId
  delete payload._oldData


  // 执行提交
  await app.request({
    api: 'api/pc/coupon/saveCouponInfo',
    data: payload
  })

  return true
}


async function loadBusinessCategoryData(app: App,model:any) {
  if (model.businessScene !== CouponBusinessScene.LIANLIAN){
    return
  }
  const res = await app.request({
    api: {
      url: 'tuxi.txsh.pc.config.queryCat'
    },
  })
  const result = res.map((item:any)=>{
      item.label = item.name;
      item.value = item.id;
      item.scene = CouponBusinessScene.LIANLIAN
      return item;
  })
  model.jsonData_llCat = result
}


// 延时处理
const reloadWriteOffRule = debound(_reloadWriteOffRule, 100)

/** 重设查询规则 */
async function _reloadWriteOffRule(app: App, model: any) {
  if (!model) return

  model.jsonData_minPriceFloor = undefined
  model.jsonData_priceFloor = undefined
  model.jsonData_writtenOffRule = ''

  if (!model.costSide || !model.couponPrice) return

  // 目前只有订单抵扣券需要请求接口
  if (model.couponType !== CouponType.ORDER_DEDUCTION) return

  const res = await app.request({
    api: {
      url: 'tuxi.dms.coupon.pc.getPriceFloor'
    },
    params: {
      costSide: model.costSide,
      couponPrice: model.couponPrice
    }
  })

  model.jsonData_minPriceFloor = res.priceFloor
  model.jsonData_priceFloor = res.priceFloor
  model.jsonData_writtenOffRule = res.formula
}
